
import { Component,Input, OnInit, TemplateRef, ViewChild } from '@angular/core';
import { NgbCalendar, NgbDate, NgbDateAdapter, NgbDateParserFormatter, NgbDatepickerI18n, NgbModal, NgbModalRef, NgbInputDatepicker } from '@ng-bootstrap/ng-bootstrap';
import { ModalConfig } from '../../../core/model/modal.config-model';
import { DateRangePickerComponent, IDateRange, IDateRangePickerOptions } from 'ngx-daterange';
import moment from 'moment';
import { DatePipe, NgClass, NgIf, NgFor } from '@angular/common';
import { UntypedFormControl, UntypedFormGroup, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { SubmitQuoteModel } from '../../../core/model/submit-quote-model';
import { CustomProductsService } from '../../../modules/custom-landing/custom-products/custom-products.service';
import { QuoteStatusModel } from 'src/app/core/model/quote-status-model';
import { QuoteEditModel } from 'src/app/core/model/quote-edit-model';
import { QuoteActionModel } from 'src/app/core/model/quote-action-model';
import { ToastrService } from 'ngx-toastr';
import { TranslationService, I18nModule } from '@spartacus/core';
import { DateRangePickerI18nService, CustomAdapter, CustomDateParserFormatter } from '../../services/date-range-picker-i18n.service';
import { TwoDigitDecimaNumberDirective, CopyDirective } from '../two-digit-decima-number.directive';

@Component({
    selector: 'app-counter-offer-modal',
    templateUrl: './counter-offer-modal.component.html',
    styleUrls: ['./counter-offer-modal.component.scss'],
    providers: [{ provide: NgbDatepickerI18n, useClass: DateRangePickerI18nService }, { provide: NgbDateAdapter, useClass: CustomAdapter },
        { provide: NgbDateParserFormatter, useClass: CustomDateParserFormatter }],
    imports: [FormsModule, TwoDigitDecimaNumberDirective, CopyDirective, NgClass, NgIf, NgFor, ReactiveFormsModule, NgbInputDatepicker, I18nModule]
})
// @Injectable(
//   {
//     providedIn: 'root',
//   })
export class CouterOfferModalComponent implements OnInit {
  @Input() public modalConfig: ModalConfig;
  @Input() public modalfocus;
  @ViewChild('modal') private modalContent: TemplateRef<CouterOfferModalComponent>;
  submitQuoteModel = new SubmitQuoteModel();
  quoteStatusModel = new QuoteStatusModel();
  quoteEditModel = new QuoteEditModel();
  quoteActionModel = new QuoteActionModel();
  private modalRef: NgbModalRef;
  firstFieldEmittedValue: IDateRange;
  secondFieldOptions: IDateRangePickerOptions = {
    clickOutsideAllowed: false,
    format: 'DD/MM/YYYY',
    icons: 'font-awesome',
    singleCalendar: true,
    minDate: moment().subtract(0, 'day'),
    maxDate: moment().add(1, 'year'),
  };
  timeSelected: any;
  timeStart = 0; // start time in hours;
  timeEnd = 24; // end time in hours;
  timeInterval = 30; // interval in min;
  @ViewChild('dateRangePicker', { static: true })
  dateRangePicker: DateRangePickerComponent;
  timeArray = [];
  startDate: NgbDate = null;
  endDate: any = null;
  datePipe = new DatePipe('en-US');
  showDateError = false;
  modalReference: any;
  form: UntypedFormGroup;
  closeResult = '';
  productInfo: any;
  closeModal: any;
  biddingTerms = '';
  quantitySelected: number;
  actualQuantitySelected:any;
  quantityRangeArray = [];
  dateSelected: any = null;
  disabledBtn = false;
  priceValue: any;
  error: string;
  counterOfferError = false;
  counterOfferErrorValue = '';
  placebidfirst: string;
  placebidsecond: string;
  placemsg: string;
  minPrice: any;
  convertedDate: any
  nextMonth: string;
  showquantity = false
  preMonth: string;
  selectMonth: string;
  selectYear: string;
  // minprice = 300;
  constructor(private router: Router, private route: ActivatedRoute,
              private customProductService: CustomProductsService, private modalService: NgbModal, private toastService: ToastrService
              // tslint:disable-next-line:align
              , private translation: TranslationService,public formatter:  NgbDateParserFormatter,
              calendar: NgbCalendar) {
                this.startDate = calendar.getToday();

  }
  ngOnInit(): void {
    this.modalfocus
    this.form = new UntypedFormGroup({
      secondDateRange: new UntypedFormControl()
    });
    for (let i = this.timeStart; i <= this.timeEnd; i++) {
      const timeString = ('0' + i).slice(-2);
      const timeStringWith0 = timeString + ':00';
      const halfTimeString = timeString + ':' + this.timeInterval;
      // this.timeArray.push(timeStringWith0);
      // this.timeArray.push(halfTimeString);
      if (halfTimeString !== '24:30'){
        this.timeArray.push(timeStringWith0);
        this.timeArray.push(halfTimeString);
      }
      // this.timeArray.push({timeValue:timeStringWith0, disabledTime:this.disableEarlyTime(timeStringWith0)});
      // this.timeArray.push({timeValue:halfTimeString, disabledTime:this.disableEarlyTime(halfTimeString)});
    }

    this.timeSelected = this.timeArray[0];
    this.translation.translate('home.toastErrorMessages.something').subscribe(res => {
      this.error = res;
    });
    this.translation.translate('home.toastErrorMessages.placebidfirst').subscribe(res => {
      this.placebidfirst = res;
    });
    this.translation.translate('home.toastErrorMessages.placebidsecond').subscribe(res => {
      this.placebidsecond = res;
    });
    this.translation.translate('home.datePicker.nextMonth').subscribe(res=>{
      this.nextMonth = res;
    })
    this.translation.translate('home.datePicker.preMonth').subscribe(res=>{
      this.preMonth = res;
    })
    this.translation.translate('home.datePicker.selectMonth').subscribe(res=>{
      this.selectMonth = res;
    })
    this.translation.translate('home.datePicker.selectyear').subscribe(res=>{
      this.selectYear = res;
    })
  }
  open(content: any, data: any): any {
    this.quantityRangeArray = [];
    this.counterOfferError = false;
    this.counterOfferErrorValue = '';
    this.productInfo = data;
    console.log(this.productInfo);
    if (data.quoteEntries && data.quoteEntries.length !== undefined && data.quoteEntries.length !== 0){
      if (data.quoteEntries[0].price){
        this.priceValue = data.quoteEntries[0].price;
        // this.minPrice = data.quoteEntries[0].minPrice ;
        if(data.quoteEntries[0].minPrice){
          this.minPrice = data.quoteEntries[0].minPrice ;
        }
      }
    }
    if (data.remark !== undefined) {
      this.biddingTerms = data.remark;
    }
    if (data.offerValidity) {
      this.dateSelected = data.offerValidity;
      const momentFormatDate = moment(data.offerValidity);
     // this.startDate = momentFormatDate.toDate();
      const momentObj = moment(data.offerValidity);
      //this.dateSelected = momentObj.format('DD/MM/YYYY');
      this.dateSelected = moment.utc(data.offerValidity).local().format('DD/MM/YYYY');
     // this.timeSelected = momentObj.local().format('HH:MM');
      this.timeSelected = moment.utc(data.offerValidity).local().format('HH:mm');
      const localDate = new Date(data.offerValidity);
      // alert(localDate);
      const localDateTime = moment(localDate);
      if (!this.timeArray.includes(this.timeSelected)){
      //  this.timeArray.push({timeValue:this.timeSelected, disabledTime:true});
        this.timeArray.push(this.timeSelected);
        if (this.timeArray.length > 0){
            this.timeArray = this.timeArray.sort(function(a, b) 
            {
               return a.localeCompare(b)  ;
              });
          }
      //   this.timeArray.sort(function (a, b) {
      //     return a.time.localeCompare(b.time);
      // });
        }
      //  disableEarlyTime();
    }

    if (data.maximumQty !== undefined && data.minimumQty !== undefined) {
      if (data.quoteEntries[0] !== undefined) {
        if(data.quoteEntries[0].quantity>=data.minimumQty){
          this.quantitySelected = data.quoteEntries[0].quantity;
          this.showquantity = false
          
        }
        else if(data.quoteEntries[0].quantity<data.minimumQty)
        {
          this.actualQuantitySelected = data.quoteEntries[0].quantity;
          this.showquantity =true
        }
        
      }

      const quantityRangeMin = Number(data.minimumQty);
      const quantityRangeMax = Number(data.maximumQty) / quantityRangeMin;
      for (let i = 1; i <= quantityRangeMax; i++) {
        this.quantityRangeArray.push(quantityRangeMin * i);
      }
      if (data.quoteEntries[0] !== undefined) {
        if (!this.quantityRangeArray.includes(this.quantitySelected)){
          this.quantityRangeArray.push(this.quantitySelected);
          if (this.quantityRangeArray.length > 0){
            this.quantityRangeArray = this.quantityRangeArray.sort(function(a, b) {  return a - b;  });
          }
        }
      }
    }
    this.modalRef = this.modalService.open(this.modalContent);
    this.modalRef.result.then();
    
    this.placemsg = this.placebidfirst + " ¥" + this.minPrice + " " + this.placebidsecond
    console.log(data.quoteEntries[0].quantity,'quantity')
  }
  isValidLetter(k): any {
    return ((k >= 48 && k <= 57));
  }
  close(): any {
    this.modalRef.close();
  }

  dismiss(): any {
    this.modalRef.dismiss();
  }
  omitSpecialChar(event): any {
    const k = event.charCode;
    return this.isValidLetter(k);
  }
  onRangeSelected(value: IDateRange): void {
    this.counterOfferError = false;
    this.counterOfferErrorValue = '';
    this.showDateError = false;
    this.firstFieldEmittedValue = value;
    // this.startDate = this.firstFieldEmittedValue.start.toDate();
    // this.filterData();
  }
  selectTimeFunction(): void {
    this.counterOfferError = false;
    this.counterOfferErrorValue = '';
  }
  onReset(event: any): void {
    this.counterOfferError = false;
    this.counterOfferErrorValue = '';
    if (event !== undefined) {
      this.dateRangePicker.reset(event);
      this.dateRangePicker.toggleCalendarVisibility(false);
    }
    //  this.dateRangePicker.toggleCalendarVisibility(false);
    // event.preventDefault();
    // event.stopPropagation();
    this.showDateError = false;
    this.startDate = null;

  }

  modalid(k): any {
    return k;
  }

  isValid(item: string): any {
    return Object.keys(item).length;
    // return objectKeys(item).length>0?true:false
  }

  isVisible(item: string): any {
    return Object.keys(item).length > 0 ? 'visible' : 'hidden';
  }
  checkPad(d){
    return (d < 10) ? '0' + d.toString() : d.toString();
  }

  onDateSelection(selectedDate){
    this.counterOfferError = false;
    this.counterOfferErrorValue = '';
    this.showDateError = false;
    this.startDate = selectedDate;
   
  }  

  editQuote(data): any {
    this.counterOfferError = false;
    this.counterOfferErrorValue = '';
    this.disabledBtn = true;
    this.quoteEditModel.quoteAction = this.quoteActionModel.counterOffer;
    this.quoteEditModel.quoteCode = data.quoteCode;
    if (data.quoteEntries[0] !== undefined){
      this.quoteEditModel.quoteEntryRequest.basePrice = this.priceValue;
      this.quoteEditModel.quoteEntryRequest.productCode = data.quoteEntries[0].productCode;
      this.quoteEditModel.quoteEntryRequest.quantity = data.quoteEntries[0].quantity;
    }
    if(data.quoteEntries[0].quantity>=data.minimumQty){
      this.quoteEditModel.quoteEntryRequest.quantity = this.quantitySelected;
    }
    else if(data.quoteEntries[0].quantity<data.minimumQty){
      this.quoteEditModel.quoteEntryRequest.quantity = this.actualQuantitySelected;
    }
    
    this.quoteEditModel.remark = this.biddingTerms;
    this.quoteEditModel.quoteTemplate = {};
    if (this.startDate != null) {
      this.convertedDate = this.startDate.year+'-'+this.checkPad(this.startDate.month)+'-'+this.checkPad(this.startDate.day);
      //const convertedDate = this.customProductService.convertDateForCounterOffer(this.startDate);
      const dateTime = moment(this.convertedDate + ' ' + this.timeSelected, 'YYYY-MM-DD HH:mm');
      // this.quoteEditModel.validity = `${convertedDate}T${this.timeSelected}:00+0000`;
      this.quoteEditModel.validity = dateTime.format();
    }else{
      const momentObj = moment(data.offerValidity);
      const dateFormat = momentObj.format('YYYY-MM-DD');
      moment().toDate();
      const dateTime = moment(dateFormat + ' ' + this.timeSelected, 'YYYY-MM-DD HH:mm');
      this.quoteEditModel.validity = dateTime.format();
    }
    this.customProductService.EditQuote(this.quoteEditModel).subscribe((res: any) => {
      if (res.status && res.status === 'BID_PLACED') {
        this.counterOfferError = false;
        this.customProductService.scrollToTop();
        this.disabledBtn = false;
        this.close();
        this.checkQuoteStatusResult(res.status);
      } else {
        this.counterOfferError = true;
        if (res.status){
              this.counterOfferErrorValue = res.status;
              this.disabledBtn = false;
        }else{
          this.toastService.show(this.error);
          this.disabledBtn = false;
        }
      }
    },
      err => {
        this.counterOfferError = true;
        if (err.error){
              this.counterOfferErrorValue = err.error;
        }else{
          this.toastService.show(this.error);
        }
        this.disabledBtn = false;
      });
  }

  checkQuoteStatusResult(quoteStatus): any {
    if (quoteStatus) {
      this.customProductService.quoteStatusName = quoteStatus;
      this.customProductService.isRedirectFromQuotesDetails = true;
      const currentUrl = this.router.url;
      if (currentUrl === '/quotes/myquotes') {
      this.router.navigateByUrl('/', {skipLocationChange: true}).then(() => {
          this.router.navigate([currentUrl]);
      });
      }else{
        this.router.navigate([`/quotes/myquotes`]);
      }
    }
  }
  homeLinkClick(value): any {
    this.customProductService.getHomeLinkActive(value);
  }
  // tslint:disable-next-line:typedef
  checkPriceValidation($event){
    // tslint:disable-next-line:prefer-const
    this.modalfocus = true
    let s = $event.target.value.split('.');
    if (s.length === 1){
      if (s[0].length >= 6) {
        $event.preventDefault();
      }
    }
  }
  ngOnDestroy(): any{
    this.modalfocus = false
  }
  validateDecimalPointPrice(e): any{
    const t = e.target.value;
    this.productInfo.priceValue = (t.indexOf('.') >= 0) ? (t.substr(0, t.indexOf('.')) + t.substr(t.indexOf('.'), 2)) : t;
    // this.cd.detectChanges();
  }
  toggle(data: any) {
    data.toggle();
    let element3 = document.getElementsByClassName("btn btn-link ngb-dp-arrow-btn");
    for(let i=0;i<element3.length;i++){
      let value = element3[i].getAttribute("title");
      console.log(value);
      element3[i].setAttribute("title",this.setTitle(value));
    }

   let element4 = document.getElementsByTagName("ngb-datepicker-navigation-select")[0].children;
   for(let i=0;i<element4.length;i++){
      let value = element4[i].getAttribute("title");
      element4[i].setAttribute("title",this.setTitle(value))
   }
  }
  setTitle(value){
    switch(value){
      case "Select year": return this.selectYear;
      case "Select month": return this.selectMonth;
      case "Next month": return this.nextMonth;
      case "Previous month": return this.preMonth;
      default : return;
    }
  }
  // disableEarlyTime(timeValue): any{
  //   const currentTime = moment();
  //   const currentTimeValue = moment(currentTime).format("hh:mm");
  //   const beginningTime = moment(timeValue, 'hh:mm');
  //   if (beginningTime.isBefore(currentTimeValue)){
  //     return true;
  //   }else{
  //     return false;
  //   }
  // }
}
